import { useEffect, useRef, useState } from 'react'

export const useLoadAll = ({ listFilterPageSort = {}, loadAll = () => { }, params = {}, reloadCounter }) => {
    const timeoutRef = useRef(null)
    const[prevPayload, setPrevPayload] = useState();

    useEffect(() => {
        const hasFilterModel = !!listFilterPageSort?.filterModel;
        const hasPaginationModel = !!listFilterPageSort?.paginationModel;
        if (Object.keys(listFilterPageSort).length > 0 && hasFilterModel && hasPaginationModel) {
            //console.info('useLoadAll:useEffect[listFilterPageSort, reloadCounter] init', Date.now())
            const { filterModel = {}, paginationModel = {}, sortModel } = listFilterPageSort
            const { page = 0, pageSize = 20 } = paginationModel
            
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }

            timeoutRef.current = setTimeout(() => {
                //console.info('useLoadAll:useEffect[listFilterPageSort, reloadCounter] eseguo chiamata server side', Date.now())
                loadAll(filterModel, sortModel, page + 1, pageSize, params.otherFilters ?? null)
            }, 200)
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [listFilterPageSort, reloadCounter, params.otherFilters])
}
